module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"live":"Live"},"fr":{"live":"Direct"}}')
  delete Component.options._Ctor
}
